import * as React from 'react'
import styled from 'styled-components'
import { colors } from '@components/shared/colors'
import { config } from 'react-awesome-styled-grid'
import type { TrackPropsType } from '../../models/Track'
import { TrackListItemComponent } from '@components/Track/TrackListItem'
import type { SeriesPropsType } from '../../models/Series'
import HeaderSection from '@components/HeaderSection'
import type { DeepLinkedCardsCarouselPropsType } from '../../models/Discover'
import DeepLinkCardsCarousel from '@components/Discover/DeepLinkCardsCarousel'
import { BenefitsSection } from '@components/BenefitsSection'
import { useSearchParams } from 'next/navigation'
import ReviewSection from '@components/ReviewSection'
import { CelebrityBanner } from '@components/Series/CelebrityBanner'
import { useSelector } from 'react-redux'
import type { AppStateType } from '@reducers/appstate'
export function SeriesDetail (props: SeriesPropsType): React.ReactNode {
  const tracks = props.tracks.filter((track: TrackPropsType): boolean => !track.isCharacterExp)
  const searchParams = useSearchParams()
  const [showSubThemeRows, setShowSubThemeRows] = React.useState(true)
  const [chaptersShown, setChaptersShown] = React.useState(true)
  const [characterExpShown, setCharacterExpShown] = React.useState(true)
  const [showQuotes, setShowQuotes] = React.useState(true)
  const subscriptionCta = useSelector((state: AppStateType): string => state.subscriptionCTA)
  React.useEffect((): void => {
    if (searchParams.get('sub')) {
      setShowSubThemeRows(false)
    }
    if (searchParams.get('ch')) {
      setChaptersShown(false)
    }
    if (searchParams.get('exp')) {
      setCharacterExpShown(false)
    }
    if (searchParams.get('q')) {
      setShowQuotes(false)
    }
  }, [searchParams])
  return (
    <SeriesDetailContainer>
    <HeaderSection
      description={props.description}
      description2={props.description}
      title={props.title}
      tags={props.thematicTags}
      ctaText={subscriptionCta}
      headerType={props.tracks.length <= 2 ? '2' : undefined }></HeaderSection>
      {props.featured && <BannerContainer><CelebrityBanner {...props.featured}/></BannerContainer>}
      {chaptersShown && (tracks.length === 0 ? props.tracks : tracks).map((track: TrackPropsType): React.ReactNode => (
        <SectionDivider key={track.id}>
          <TrackListItemComponent {...track} key={track.id} hideSeriesInfo playIndicator/>
        </SectionDivider>
      ))}
      {characterExpShown && props.characterExperiences.map((item: DeepLinkedCardsCarouselPropsType, index: number): React.ReactNode =>
        <SectionDivider key={`${props.id}-characterexp-${index}`}><DeepLinkCardsCarousel {...item}/></SectionDivider>
      )}
      {showSubThemeRows && props.themeRows.map((item: DeepLinkedCardsCarouselPropsType, index: number): React.ReactNode =>
        <SectionDivider key={`${props.id}-subthemerow-${index}`}><DeepLinkCardsCarousel {...item}/></SectionDivider>
      )}
      {showQuotes && <ReviewSection title={`WHAT LISTENERS ARE SAYING`} slides={props.quotes}/>}
      <BenefitsSection/>
    </SeriesDetailContainer>
  )
}

const BannerContainer = styled.div<any>`
  margin-top: 24px;
  margin-bottom: 36px;
  width: 100%;
  display: flex;
  justify-content: center;
  ${(props: any): any => config(props).media.sm`
    margin-top: 24px;
  `}
`

const SeriesDetailContainer = styled.div<any>`
  display: flex;
  flex-direction: column;
`

const SectionDivider = styled.div<any>`
  padding: 15px 0;
  border-bottom: 1px solid ${colors.white25};
  ${(props: any): any => config(props).media.md`
    padding: 30px 0;
  `}
`
